export enum PaymentsConditionsEnum {
  EmailConfirmed = 'email_confirmed',
  MinBalanceAvailable = 'min_balance_available',
  ProfitForPeriodReceived = 'profit_for_period_received',
  KycVerified = 'kyc_verified',
}
